/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemAvailableDiscount,
  LineItemAvailableDiscountOptional,
  LineItemAvailableDiscountMetaI,
  LineItemAvailableDiscountTrackedI,
} from "./line-item-available-discount";
import {
  LineItemAvailableDiscountTracked,
  LineItemAvailableDiscountMeta,
} from "./line-item-available-discount";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderDTO,
  OrderDTOOptional,
  OrderDTOMetaI,
  OrderDTOTrackedI,
} from "./order-dto";
import { OrderDTOTracked, OrderDTOMeta } from "./order-dto";

/**
 *
 * @export
 * @interface OrderWithDiscountsDTO
 */
export interface OrderWithDiscountsDTOOptional {
  /**
   *
   * @type {OrderDTO}
   * @memberof OrderWithDiscountsDTO
   */
  order?: OrderDTOOptional;
  /**
   *
   * @type {Array<LineItemAvailableDiscount>}
   * @memberof OrderWithDiscountsDTO
   */
  availableDiscounts?: LineItemAvailableDiscountOptional[];
}

export interface OrderWithDiscountsDTO extends OrderWithDiscountsDTOOptional {
  /**
   *
   * @type {OrderDTO}
   * @memberof OrderWithDiscountsDTO
   */
  order?: OrderDTO;
  /**
   *
   * @type {Array<LineItemAvailableDiscount>}
   * @memberof OrderWithDiscountsDTO
   */
  availableDiscounts?: LineItemAvailableDiscount[];
}

export interface OrderWithDiscountsDTOTrackedI {
  /**
   *
   * @type {OrderDTO}
   * @memberof OrderWithDiscountsDTO
   */
  order?: OrderDTOTrackedI;
  orderIsSet: boolean;
  /**
   *
   * @type {Array<LineItemAvailableDiscount>}
   * @memberof OrderWithDiscountsDTO
   */
  availableDiscounts?: LineItemAvailableDiscountTrackedI[];
  availableDiscountsIsSet: boolean;
}

transformDatesMap.set(
  "OrderWithDiscountsDTO",
  function (model: OrderWithDiscountsDTO) {
    const transformDatesorder = transformDatesMap.get("OrderDTO");
    if (transformDatesorder && model.order) {
      transformDatesorder(model.order);
    }
    const transformDatesavailableDiscounts = transformDatesMap.get(
      "LineItemAvailableDiscount",
    );
    if (transformDatesavailableDiscounts) {
      model.availableDiscounts?.forEach((sub) => {
        transformDatesavailableDiscounts(sub);
      });
    }
  },
);

export type OrderWithDiscountsDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  order: PropertyMeta<OrderDTOMetaI>;
  //isDate: false
  //isDatetime: false
  availableDiscounts: PropertyMeta<LineItemAvailableDiscountMetaI>;
}>;

export var OrderWithDiscountsDTOMeta: OrderWithDiscountsDTOMetaI =
  {} as OrderWithDiscountsDTOMetaI;
OrderWithDiscountsDTOMeta = typeMeta("OrderWithDiscountsDTO", {
  order: propertyMeta("order", false, false, false, OrderDTOMeta),
  availableDiscounts: propertyMeta(
    "availableDiscounts",
    true,
    false,
    false,
    LineItemAvailableDiscountMeta,
  ),
});

const metaI = OrderWithDiscountsDTOMeta;

registerMeta(() => {});

export class OrderWithDiscountsDTOTracked implements OrderWithDiscountsDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  order__I?: OrderDTOTracked = undefined;
  orderIsSet: boolean = false;
  set order(v: undefined | OrderDTOTracked) {
    if (v !== undefined) {
      this.order__I = v;
      this.orderIsSet = true;
    } else {
      this.order__I = v || undefined;
      this.orderIsSet = false;
    }
    this.changeTracker = true;
  }
  get order() {
    return this.order__I;
  }
  availableDiscounts__I?: LineItemAvailableDiscountTracked[] = undefined;
  availableDiscountsIsSet: boolean = false;
  set availableDiscounts(v: undefined | LineItemAvailableDiscountTracked[]) {
    if (v !== undefined) {
      this.availableDiscounts__I = v;
      this.availableDiscountsIsSet = true;
    } else {
      this.availableDiscounts__I = v || undefined;
      this.availableDiscountsIsSet = false;
    }
    this.changeTracker = true;
  }
  get availableDiscounts() {
    return this.availableDiscounts__I;
  }
  constructor(config?: OrderWithDiscountsDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.order?.setIds();

    this.availableDiscounts?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: OrderWithDiscountsDTOOptional,
    options?: AssignOptions,
  ): OrderWithDiscountsDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.order && this.orderApplyFilter(optionsRequired.filter)) {
      this.order = new OrderDTOTracked(config.order, options);
      if (optionsRequired.unassign) this.orderIsSet = false;
      else this.orderIsSet = true;
    }
    if (
      config.availableDiscounts &&
      this.availableDiscountsApplyFilter(optionsRequired.filter)
    ) {
      this.availableDiscounts = config.availableDiscounts?.map(
        (a) => new LineItemAvailableDiscountTracked(a, options),
      );
      if (optionsRequired.unassign) this.availableDiscountsIsSet = false;
      else this.availableDiscountsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): OrderWithDiscountsDTOTrackedI {
    const cloned = {} as OrderWithDiscountsDTOTrackedI;
    if (
      this.orderIsSetDeep() &&
      this.orderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.orderIsSet = true;
      cloned.order = this.order?.removeUnset(filter);
    } else {
      //cloned.orderIsSet = false
    }
    if (
      this.availableDiscountsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.availableDiscountsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.availableDiscountsIsSet = true;
      cloned.availableDiscounts = this.availableDiscounts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.availableDiscountsIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): OrderWithDiscountsDTOTrackedI {
    if (!this.orderApplyFilter(filter)) this.orderIsSet = false;
    this.order?.unassignAll(filter);

    if (!this.availableDiscountsApplyFilter(filter))
      this.availableDiscountsIsSet = false;

    this.availableDiscounts?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  orderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderWithDiscountsDTOMeta.order,
      OrderWithDiscountsDTOMeta,
      this.order,
      this,
    );
  }
  orderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.orderIsSet && this.orderApplyFilter(filter)) return true;
    return this.order?.anySet(filter) == true;

    return false;
  }
  availableDiscountsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderWithDiscountsDTOMeta.availableDiscounts,
      OrderWithDiscountsDTOMeta,
      this.availableDiscounts,
      this,
    );
  }
  availableDiscountsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.availableDiscountsIsSet &&
      this.availableDiscountsApplyFilter(filter)
    )
      return true;

    return this.availableDiscounts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.orderIsSetDeep(filter)) return true;
    if (this.availableDiscountsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
